package com.schoolconnect.app.feature.common

data class ServerPageTotalCount(
    val totalCount: Int,
    val isExact: Boolean
)

internal data class ServerPageLoadState(
    val paging: ServerPagingState,
    val window: ServerPagedWindow,
    val clampedPageIndex: Int
)

internal fun resolveServerPageTotal(
    exactTotal: Int?,
    paging: ServerPagingState,
    currentItemCount: Int,
    pageOffset: Int = paging.offset()
): ServerPageTotalCount {
    exactTotal?.let { total ->
        return ServerPageTotalCount(
            totalCount = total.coerceAtLeast(0),
            isExact = true
        )
    }

    val safePageSize = paging.pageSize.coerceAtLeast(1)
    val hasAnotherPage = currentItemCount >= safePageSize
    val estimatedTotal = if (hasAnotherPage) {
        pageOffset + currentItemCount + 1
    } else {
        pageOffset + currentItemCount
    }

    return ServerPageTotalCount(
        totalCount = estimatedTotal.coerceAtLeast(currentItemCount),
        isExact = !hasAnotherPage
    )
}

internal fun resolveServerPageLoadState(
    exactTotal: Int?,
    paging: ServerPagingState,
    currentItemCount: Int,
    pageOffset: Int = paging.offset()
): ServerPageLoadState {
    val pageTotal = resolveServerPageTotal(
        exactTotal = exactTotal,
        paging = paging,
        currentItemCount = currentItemCount,
        pageOffset = pageOffset
    )
    val nextPaging = paging.withTotals(
        totalCount = pageTotal.totalCount,
        isTotalCountExact = pageTotal.isExact
    )
    val window = nextPaging.toWindow(currentItemCount)
    val clampedPageIndex = nextPaging.pageIndex.coerceAtMost(maxOf(0, window.pageCount - 1))
    return ServerPageLoadState(
        paging = nextPaging,
        window = window,
        clampedPageIndex = clampedPageIndex
    )
}
